import React from 'react';

import { Skeleton } from '@mui/material';
import { t } from 'i18next';

import BdsCardContainer from '../../../../../../shared/components/v3/Cards/BdsCardContainer/BdsCardContainer';
import ErrorCard from '../../../../../../shared/components/v3/Cards/ErrorCard/ErrorCard';
import VerticalBarChart from '../../../../../../shared/components/v3/Charts/VerticalBarChart/VerticalBarChart';
import { IVerticalBarChartItem } from '../../../../../../shared/interfaces/charts';
import { IMetricsChallengeByType } from '../../../../../../shared/interfaces/metrics';
import { TRANSLATIONS_METRICS_NE } from '../../../../../../shared/translations/metrics';

import './ChallengesByTypeCard.scss';

interface IChallengesByTypeCard {
  data: IMetricsChallengeByType[];
  loading: boolean;
  error: boolean;
  onRetry?: () => void;
}

const toChartItem = (item: IMetricsChallengeByType, index: number): IVerticalBarChartItem => ({
  key: item.type ?? `${index}`,
  label: item.name ?? item.type ?? '',
  icon: item.icon,
  value: item.participationRate ?? 0
});

const ChallengesByTypeCard = ({ data, loading, error, onRetry }: IChallengesByTypeCard) => {
  if (loading) {
    return <Skeleton className="rounded-4xl" variant="rectangular" width="100%" height={300} />;
  }

  return (
    <BdsCardContainer className="challenges-by-type-card" paddingSize="padding-l" borderRadiusSize="radius-l">
      <h3 className="challenges-by-type-title">{t(TRANSLATIONS_METRICS_NE.challenges.challengeType.title)}</h3>
      {error ? (
        <ErrorCard
          primaryText={t(TRANSLATIONS_METRICS_NE.challenges.error.title)}
          secondaryText={t(TRANSLATIONS_METRICS_NE.challenges.error.description)}
          buttonText={t(TRANSLATIONS_METRICS_NE.challenges.retry)}
          action={onRetry}
        />
      ) : (
        <VerticalBarChart data={data.map((item, index) => toChartItem(item, index))} />
      )}
    </BdsCardContainer>
  );
};

export default ChallengesByTypeCard;
